module.exports = __webpack_public_path__ + "static/img/logo13.bcc719b.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/logo/logo13.png
// module id = w1QW
// module chunks = 1